/* eslint-disable no-shadow */
const state = {
	scope: 'summaries',
	limit: 12,
};

const getters = {

};

const mutations = {

};

const actions = {
	'summaries/list': async function ({ dispatch, commit, state, getters }, reset = false) {
		commit('SET_DATA_LOADING', { value: true, type: state.scope });

		let offset;
		if (reset) offset = 0; else offset = getters[`data/${state.scope}`].results.length;

		const summaries = await this.$sdk.summaries().list({ offset, limit: state.limit, see_future: 1 });

		const result = {
			ok: false,
			state: 'complete',
		};

		if (summaries.ok) {
			result.ok = true;

			dispatch('addData', { data: summaries.data, type: state.scope, reset });

			if (offset < summaries.data.total) result.state = 'loaded';
		}

		commit('SET_DATA_LOADING', { value: false, type: state.scope });

		return result;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
